<template>
  <div class="col-md-2 mb-4">
    <div class="large-card">
      <div class="img-wrapper single-pic">
        <a href="#" class="img-position">
          <div class="img-prev" v-if="item.template">
            <img :src="getImage(item.template.img)" alt="" />
          </div>
        </a>
      </div>
      <div class="content-wrapper">
        <div class="textBlock">
          <h5 v-if="item.template">Rarity {{item.template.rarity}}</h5>
          <h5 v-if="!countDownEnded">Reward time</h5>
          <h5 v-if="!countDownEnded">{{timerDisplay}}</h5>
        </div>
        <div class="content">
          <div class="buttons px-3">
            <a href="#">
              <button
                type="button"
                class="btn btn-stake btn-block w-100"
                v-if="countDownEnded"
                @click.prevent="claim(item.id)">
                Claim
              </button>
              <button
                type="button"
                class="btn btn-stake btn-block w-100"
                v-if="!countDownEnded"
                @click.prevent="unstake(item.id)">
                Unstake
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  </template>
<script>
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import { useToast } from "vue-toastification";
import ApiService from "../services";
const toast = useToast();
export default {
  name: "Staked",
  props: ["error", "item"],
  showModal: true,
  data() {
    return {
      info: null,
      isLoading: false,
      isImageLoaded: false,
      icon: "captain.jpeg",
      isSelected: false,
      stakeOver: false,
      counter: 0,
      leftHours: 0,
      timerDisplay: 0,
      countDown: null,
      countDownEnded: false,
    };
  },
  mounted() {
    this.calculateTime();
  },
  methods: {
    calculateTime() {
      if (!this.stakeOver && !this.countDown && this.item.end_time) {
        let startDate = moment.utc().format("YYYY-MM-DD HH:mm:ss");
        let endDate = moment
          .utc(this.item.end_time)
          .format("YYYY-MM-DD HH:mm:ss");
        var seconds = moment
          .duration(moment(endDate).diff(moment(startDate)))
          .asSeconds();
        this.interval = setInterval(() => {
          const days = Math.floor(seconds / 86400);
          const remainingMillies = (seconds % 86400) * 1000;
          this.timerDisplay = `${days} day(s) and ${moment
            .utc(remainingMillies)
            .format("HH:mm:ss")}`;
          seconds--;
          if (seconds === 0 || days < 0 || this.countDownEnded) {
            this.countDownEnded = true;
            this.timerDisplay = "Stake finished!";
            clearInterval(this.interval);
          }
        }, 1000);
      } else {
        clearInterval(this.countDown);
      }
    },
    loaded() {
      this.isImageLoaded = true;
    },
    getImage(hash) {
      hash = hash=="QmUvvGstFtC8Vo8AkegtnDGv75oWxdxkB1phL6Gbn4L4Xm"?"QmWmcKagxLtbuHg2z1EFe42j8mPpxNTpBz1tyF7KnLpuMu":hash;
      let url = "http://ipfs.io/ipfs/" + hash;
      return "//lostsailor/images.weserv.nl/?url=" + url + "&w=200";
    },
    async claim(id) {
      ApiService.transaction({
        action:"claimstake",
        contract:process.env.VUE_APP_CONTRACT,
        data:{
          account:localStorage.getItem("wax_user"),
          id:id
        }
      },(res) => {
          if (res.processed) {
            toast.success("Reward claimed...");
            this.$emit("refresh-data");
          }
        })
    },
    async unstake(id) {
      ApiService.transaction({
        action:"unstake",
        contract:process.env.VUE_APP_CONTRACT,
        data:{
          account:localStorage.getItem("wax_user"),
          id:id
        }
      },(res) => {
          if (res.processed) {
            toast.success("unstaked successfully");
            this.$emit("refresh-data");
          }
        })
    }
  },
};
</script>
<style scoped>
.responsive-img {
  width: 80px;
}
.stake-block {
  margin: 10px;
  background: transparent;
  border: 3px solid #f1f1f1;
  padding: 10px;
  height: 125px;
}
.btn-claim {
  width: 120px;
}
.large-card {
    display: inline-block;
    position: relative;
    height: -webkit-fit-content;
    height: -moz-fit-content;
    height: fit-content;
    border-radius: 10px;
    margin-right: 10px;
    width: 173px;
    max-width: 100%;
    max-height: 100%;
    box-shadow: 0 3px 20px rgb(0 0 0 / 40%);
    background: #8e8c76;
}
</style>